import { SVGIconComponent } from './types';

export const ProjectTypeRegion: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, ...style }}
    className={className}
  >
    <path
      fill="currentColor"
      d="M5.4 0a1.8 1.8 0 0 1 1.8 1.8v.6h3.6v-.6A1.8 1.8 0 0 1 12.6 0h3.6A1.8 1.8 0 0 1 18 1.8v3.6a1.8 1.8 0 0 1-1.8 1.8h-.6v3.6h.6a1.8 1.8 0 0 1 1.8 1.8v3.6a1.8 1.8 0 0 1-1.8 1.8h-3.6a1.8 1.8 0 0 1-1.8-1.8v-.6H7.2v.6A1.8 1.8 0 0 1 5.4 18H1.8A1.8 1.8 0 0 1 0 16.2v-3.6a1.8 1.8 0 0 1 1.8-1.8h.6V7.2h-.6A1.8 1.8 0 0 1 0 5.4V1.8A1.8 1.8 0 0 1 1.8 0Zm-.6 13.2H2.4v2.4h2.4zm10.8 0h-2.4v2.4h2.4zm-4.8-8.4H7.2v.6a1.8 1.8 0 0 1-1.8 1.8h-.6v3.6h.6a1.8 1.8 0 0 1 1.8 1.8v.6h3.6v-.6a1.8 1.8 0 0 1 1.8-1.8h.6V7.2h-.6a1.8 1.8 0 0 1-1.8-1.8zm4.8-2.4h-2.4v2.4h2.4zm-10.8 0H2.4v2.4h2.4z"
    />
  </svg>
);
